module.exports = __webpack_public_path__ + "img/error-fill-red.edf97311.svg";